import { Button, Grid, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import squiggleLogo from "../../assets/images/Squiggle_Logo_White.png";
import backgroundImage from "../../assets/images/login_background_image.png";
import Loader from "../../components/Loader";
import { showSnackbar } from "../../slice/snackbarSlice";
import { resetPasswordAction } from "../../thunks/auth";
import { NOTIFICATION_MESSAGE, VALIDATION_MSG } from "../../utils/constant";

const ResetPassword = () => {
  // hooks
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formInputs, setFormInputs] = useState({ password: "", email: "" });
  const [isLoader, setLoader] = useState(false);
  const [isFormInvalid, setIsFormInvalid] = useState(false);

  const handleInputChange = (e) => {
    setFormInputs({ ...formInputs, [e.target.name]: e.target.value });
  };

  const handleResetPassword = async () => {
    // proceed to Reset Password
    setIsFormInvalid(true);
    try {
      setLoader(true);
      const payload = {
        password: formInputs?.password,
        email: localStorage.getItem("email"),
      };
      const responseData = await dispatch(
        resetPasswordAction(payload)
      ).unwrap();
      if (responseData) {
        setLoader(false);
        dispatch(
          showSnackbar({
            message: NOTIFICATION_MESSAGE?.CHANGE_PASSWORD_SUCCESS,
            severity: "success",
          })
        );
        localStorage.removeItem("email");
        navigate("/login", {
          state: {
            ...formInputs,
            // date: futureDate,
            email: responseData.data.email,
          },
        });
      }
    } catch (error) {
      setLoader(false);
      dispatch(
        showSnackbar({
          message: error?.message,
          severity: "error",
        })
      );
    }
  };

  return (
    <div style={{ margin: "0px" }}>
      {/* Loader Component */}
      {isLoader && <Loader />}
      <Container fluid className="h-100">
        <Row>
          <Col xs={7} className="left-col">
            {/* Content for the left column */}
            <div className="backgroundImageWrapper">
              <div
                className="backgroundImageContainer"
                style={{
                  backgroundImage: `url(${backgroundImage})`,
                }}
              >
                <img
                  style={{ height: "100px" }}
                  src={squiggleLogo}
                  alt="squiggle"
                />
              </div>
            </div>
          </Col>
          <Col xs={5} className="right-col">
            {/* Content for the right column */}
            <div className="content">
              <Grid container spacing={3} style={{ marginTop: 0 }}>
                <Grid item xs={12} sx={{ marginBottom: "1rem" }}>
                  <TextField
                    fullWidth
                    className="inputTextField"
                    placeholder="New Password"
                    variant="standard"
                    size="small"
                    name="password"
                    type="password"
                    error={isFormInvalid && !formInputs?.password}
                    helperText={
                      isFormInvalid &&
                      !formInputs?.password &&
                      VALIDATION_MSG.REQUIRED
                    }
                    onChange={(e) => handleInputChange(e)}
                    value={formInputs.password}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    className="forgotPasswordResetPassword"
                    disableElevation
                    onClick={(e) => handleResetPassword(e)}
                    style={{
                      backgroundColor: "#00ce3f",
                      borderRadius: "20px",
                      width: "200px",
                    }}
                  >
                    Proceed to Login
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <div>
                    <Typography
                      className="forgotPasswordTitle"
                      onClick={() => navigate("/forgot-password")}
                    >
                      ForgotPassword ?
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ResetPassword;
